<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="RAAS"
    >
        <template v-if="loaded">
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.origensPaciente"
                            :validations="validations.origemPaciente"
                            label="Origem do paciente"
                            show-default-option
                            text-field="nome"
                            v-model="model.origemPacienteId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.destinosPaciente"
                            :validations="validations.destinoPaciente"
                            label="Destino do paciente"
                            show-default-option
                            text-field="nome"
                            v-model="model.destinoPacienteId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.motivosSaidaPermanencia"
                            :validations="validations.motivoSaidaPermanencia"
                            label="Motivo de saída/permanência"
                            show-default-option
                            text-field="nome"
                            v-model="model.motivoSaidaPermanenciaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.carateresAtendimento"
                            :validations="validations.caraterAtendimento"
                            label="Caráter do atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.caraterAtendimentoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :disabled="!additionals.hasProcedimentoRaasQuePrecisaDeAutorizacao"
                            :validations="validations.numeroAutorizacao"
                            label="Número da autorização"
                            number
                            v-model="model.numeroAutorizacao"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!additionals.hasProcedimentoRaasQuePrecisaDeClassificacao"
                            :options="form.classificacoes"
                            :validations="validations.classificacao"
                            label="Classificação"
                            show-default-option
                            text-field="nome"
                            v-model="model.classificacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.locaisRealizacaoExame"
                            :validations="validations.localRealizacaoExame"
                            label="Local de realização do exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.localRealizacaoExameId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-area title="Procedimentos">
                <rkm-table
                    :fields="procedimentoFields"
                    :items="form.procedimentos"
                    hide-filters
                />
            </rkm-area>
        </template>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { repository, error, object, stringCase } from '@/mixins'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                origemPaciente: { required: true },
                destinoPaciente: { required: true },
                motivoSaidaPermanencia: { required: true },
                caraterAtendimento: { required: true },
                numeroAutorizacao: { required: this.additionals.hasProcedimentoRaasQuePrecisaDeAutorizacao, max: 13 },
                classificacao: { required: this.additionals.hasProcedimentoRaasQuePrecisaDeClassificacao },
                localRealizacaoExame: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            formularioRaas: this.getConectaSusRepository('ambulatorio.formularioRaas')
        }
    },
    data: () => ({
        loaded: false,
        additionals: null,
        form: null,
        model: null,
        atendimentoId: null,
        procedimentoFields: [
            { key: 'codigo', label: 'Código', sortable: true },
            { key: 'nome', label: 'Nome', sortable: true },
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(atendimentoId) {

            this.loaded = false
            this.atendimentoId = atendimentoId

            this.load()

            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.formularioRaas.create({ atendimento_id: this.atendimentoId })
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.formularioRaas.store(this.camelObjectKeysToSnakeRecursive({
                        ...this.model,
                        atendimento_id: this.atendimentoId
                    }))
                        .then(() => {

                            this.showSaveNotification()

                            this.$refs.Modal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        }
    },
    mixins: [repository, error, object, stringCase],
}
</script>